// This function allow to reference chunks
__webpack_require__.miniCssF = function(chunkId) {
  // return url for filenames not based on template
  if ({ "index":1,"vendors-node_modules_mui_material_Button_Button_js-node_modules_mui_material_DialogActions_Di-7f4795":1 }[chunkId]) return "static/css/" + chunkId + ".css";
  // return url for filenames based on template
  return "static/css/async/" + chunkId + ".css"
}